module.exports = __webpack_public_path__ + "media/images/pt/chart_big-c74c591ca424924b8927ab28b51bdfbf.png";